<template>
	<div v-show="bodyIsShow">
		<div v-if="autoShowInfo.tAutoshowPeriodsOcpc != null">
			 <input type="hidden" id="ocpcId" name="ocpcId" :value="autoShowInfo.tAutoshowPeriodsOcpc.ocpcId" />
            <input type="hidden" id="promotionCanal" name="promotionCanal" :value="autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal" />
		</div>
		<input type="hidden" id="showAddress" :value="showAddress">
		<div class="bigbodywrap">
			<section style="height:5.1rem">
				<mt-swipe :auto="4000">
                	<mt-swipe-item  v-if="autoShowInfo.headerImg!=''">
                        <div class="banner clearfix swiper-slide">
							<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl + autoShowInfo.headerImg" />
						</div>
                    </mt-swipe-item>
                    <mt-swipe-item  v-if="autoShowInfo.headerImgb!=''">
                        <div class="banner clearfix swiper-slide">
							<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl + autoShowInfo.headerImgb" />
						</div>
                    </mt-swipe-item>
                    <mt-swipe-item   v-if="autoShowInfo.headerImgc!=''">
                        <div class="banner clearfix swiper-slide">
							<img :src="commmonWebConfig.picHost + autoShowInfo.picUrl + autoShowInfo.headerImgc" />
						</div>
                    </mt-swipe-item>
                </mt-swipe>
			</section>
			<div v-if="autoShowInfo && (autoShowInfo.showCountdown == true)" class="count-timer">
				<input type="hidden" id="timeVal" :value="deadline" />
				<ul class="showtime clearfix" id="showTime">
					<li class="timer">
						<em class="gradientFont">即将结束：</em>
					</li>
					<li>
						<em class="redsize day gradient">00</em>
					</li>
					<li>
						<em class="timerFont">天</em>
					</li>
					<li>
						<em class="redsize hour gradient">00</em>
					</li>
					<li>
						<em class="timerFont">时</em>
					</li>
					<li>
						<em class="redsize min gradient">00</em>
					</li>
					<li>
						<em class="timerFont">分</em>
					</li>
					<li>
						<em class="redsize sec gradient">00</em>
					</li>
					<li>
						<em class="timerFont">秒</em>
					</li>
				</ul>
			</div>
			<div class="addxyroom">
				<p class="marB titleSign1">报名可免费领票</p>
				<p class="titleSign2">注：非报名用户需购票入场20/张</p>
			</div>
			
			<section id="formwrapSection" class="formwrapSection clearfix bac">
				<div class="formwrap">
					<form id="signUpfrom" class="signUpfrom" action="/hmtcj/applyForTcj" method="post">
						<input type="hidden" id="groupbyNum" name="groupbyNum" :value="periodsInfo.id" />
						<input type="hidden" id="position" name="position" value="1" />
						<input type="hidden" id="groupbyType" name="groupbyType" value="1" />
						<div class="sinform">
                            <em class="icon-arror-l"></em>
                            <div @click="getData($event)" class="sinform-text" id="insertCar">请选择意向品牌或车型</div>
                            <div class="icon-arror-r"></div>
                        </div>
		                <div class="sinform">
		                    <em class="signUpfrom-icon signUpfrom-icon01"></em>
		                    <input type="text" class="sinform-text" name="usernane" placeholder="请输入姓名" maxlength="10" id="usernane">
		                </div>
		                <div class="sinform">
		                    <em class="signUpfrom-icon signUpfrom-icon02"></em>
		                    <input type="tel" autocomplete="off" class="sinform-text" name="Phone" placeholder="请输入手机号码" maxlength="11" id="Phone">
		                </div>
		                <div class="sub-wrap">
                            <div :class="['singsubmit','tobtn',{'noclick':isclick}]" @click="submitSignup('#usernane','#Phone','#insertCar')" data-track="carfestivalDetailToutiao-1-signUp" id="index-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
                                <span class="line">￥20<em></em></span>立即报名
                            </div>
		                </div>
						<div style="margin-bottom:1em;color:#999" class="addxyroom">*温馨提示,报名即视为同意<a href="javascript:void(0);" class="addxydetail" @click="addxydetail()">《个人信息保护声明》</a> </div>
					</form>
					<!--广告位-->
					<section v-if="adSpaceObj != null" id="showBanner" class="showBanner">
						<img :data-isshowpop="adSpaceObj.labelDesc" :data-gotolink="adSpaceObj.text" data-track="carfestivalDetail-10-linkToAd"
						 class="scrollLoading trackEvent" :src="commmonWebConfig.static+'/img/common/blank.gif'" :data-url="commmonWebConfig.static+adSpaceObj.imageName">
					</section>
				</div>
				<section>
					<div v-if="autoShowInfo.showApplynum == true" class="music-bigwrap clearfix">
						<div class="musicsize">已有
							<em>{{appPersonNum}}</em>人领取门票</div>
						<div id="music" class="music clearfix" >
							<div class="musicicon"></div>
							<div  class="showPerson" id="showPerson"  style="height: 30px;">
		                        <!--<div   style="height: 40px;">
	                                <ul v-if="applyListMap.length > 0" class="musiclist" style="height: 100px;">-->
	                            <div>
	                                <ul v-if="applyListMap.length > 0" class="musiclist" >
							<!--<div id="showPerson" class="showPerson">
									<ul v-if="applyListMap.length > 0" class="musiclist">-->
											<li v-for="(item,index) in applyListMap" class="name">
												<span>{{item.username}}</span>
												<span>{{item.userphone}}</span>
												<span>已<span v-if="autoShowInfo.isShowTmallUrl != 1">免费</span>领票</span>
											</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div v-else class="music-bigwrap music-bigwrapNoNum clearfix">
						<div id="music" class="music clearfix">
							<div class="musicicon"></div>
							<div  class="showPerson" id="showPerson"  style="height: 30px;">
		                        <!--<div   style="height: 40px;">
	                                <ul v-if="applyListMap.length > 0" class="musiclist" style="height: 100px;">-->
	                                <div>
	                                <ul v-if="applyListMap.length > 0" class="musiclist">	
										<li v-for="(item,index) in applyListMap" class="name">
											<span>{{item.username}}</span>
											<span>{{item.userphone}}</span>
											<span>已<span v-if="autoShowInfo.isShowTmallUrl != 1">免费</span>领票</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</section>
			</section>
			<section>
				<div class="processwrap clearfix">
					<div class="fastknow clearfix">
						<div class="left-wrap">
							<div v-if="autoShowInfo.applyprocessList && autoShowInfo.applyprocessList.length > 0 && (autoShowInfo.showApplyprocess == true)" class="clearfix tickwrap"  @click="signupPage()">
								<ul class="tickwrap-in">
									<li v-for="(item,index) in autoShowInfo.applyprocessList" class="tick">
										<div class="techCon"><em class="techCone">{{item.text}}</em></div>
										<img class="techIcon" :src="commmonWebConfig.webCommonUtils+'/img/mapply/carExpo/tecgRig.png'" v-show="index!=3"/>
										<div class="clears"></div>
									</li>
								</ul>
							</div>
							<img  v-else width="100%" :src='commmonWebConfig.webCommonUtils+"/img/mapply/carExpo/ticketimg.png"' @click="signupPage()"></img>
						</div>
					</div>
				</div>
				
			</section>
			<div class="gifBac" v-show="periodsInfo.giftPrice!=null">
				<div class="gifBacImg" >
					<div class="gifCar"><p>买车</p><p>即送</p></div>
					<div class="lineX"></div>
					<div class="gifPri">
						<div class="giftt">价值<span class="priceValue">{{periodsInfo.giftPrice}}</span>大礼包</div>
						<div class="gift">新车装潢大礼包</div>
					</div>
					<div class="clears"></div>
				</div>
			</div>
			<!-- 精美礼品 -->
			<div  class="exhibitionbrand">
		        <span data-v-05565613="" class="lineL"></span> {{periodsInfo.presentTitle}}
				<span data-v-05565613="" class="lineR"></span>
			</div>
			<section v-if="(autoShowInfo.presentList.length) > 0 && periodsInfo.present==true" class="marB1 clearfix">
				<div class="gifBacTab">
					<div @click="tabData(0)" v-bind:class="[{gifBtn:presentListTit0!=''},'marginRight','marginLeft',{active:0==isActive}]">{{presentListTit0}}</div>
					<div  v-bind:class="[{gifBtn:presentListTit1!=''},'marginRight',{active:1==isActive}]" @click="tabData(1)">{{presentListTit1}}</div>
					<div  v-bind:class="[{gifBtn:presentListTit2!=''},'marginRight',{active:2==isActive}]" @click="tabData(2)">{{presentListTit2}}</div>
					<div  v-bind:class="[{gifBtn:presentListTit3!=''},{active:3==isActive}]" @click="tabData(3)">{{presentListTit3}}</div>
					<div class="clears"></div>
					<div class="gift-Show clearfix" style="margin-top: 0.2rem;">
					<div class="gift-Show-in" id="scrol1Obj" @scroll="tabScroll()">
						<ul class="giftScoll"  :style="'width:'+numbers+'rem'" >
							<li v-for="(item,index) in autoShowInfo.presentList" class="giftlist-car scrol1"  v-show="0 == item.labelType" @click="signupPage()">
								<input type="text" id="numb" :value="item.length" hidden="hidden"/>
								<em :class="[{'register':item.labelType==0},{'thecar':item.labelType==1},{'prize':item.labelType==2},{'prize':item.labelType==3}]" ></em>
								<a href="javascript:void(0);" >
									<div class="clearfix">
										<img class="fl "  style="height: 2.4rem;" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName" />
									</div>
									<div class="git-tit">{{item.text}}</div>
								</a>
							</li>
							<li v-for="(item,index) in autoShowInfo.presentList" class="giftlist-car scrol2" v-show="1 == item.labelType" @click="signupPage()">
								<input type="text" id="numb" :value="item.length" hidden="hidden"/>
								<em :class="[{'register':item.labelType==0},{'thecar':item.labelType==1},{'prize':item.labelType==2},{'prize':item.labelType==3}]" ></em>
								<a href="javascript:void(0);" >
									<div class="clearfix">
										<img class="fl "  style="height: 2.4rem;" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName" />
									</div>
									<div class="git-tit">{{item.text}}</div>
								</a>
							</li>
							<li v-for="(item,index) in autoShowInfo.presentList" class="giftlist-car scrol3" v-show="2 == item.labelType" @click="signupPage()">
								<input type="text" id="numb" :value="item.length" hidden="hidden"/>
								<em :class="[{'register':item.labelType==0},{'thecar':item.labelType==1},{'prize':item.labelType==2},{'prize':item.labelType==3}]" ></em>
								<a href="javascript:void(0);" >
									<div class="clearfix">
										<img class="fl "  style="height: 2.4rem;" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName" />
									</div>
									<div class="git-tit">{{item.text}}</div>
								</a>
							</li>
							<li v-for="(item,index) in autoShowInfo.presentList" class="giftlist-car scrol4" v-show="3 == item.labelType" @click="signupPage()">
								<input type="text" id="numb" :value="item.length" hidden="hidden"/>
								<em :class="[{'register':item.labelType==0},{'thecar':item.labelType==1},{'prize':item.labelType==2},{'prize':item.labelType==3}]" ></em>
								<a href="javascript:void(0);" >
									<div class="clearfix">
										<img class="fl "  style="height: 2.4rem;" v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName" />
									</div>
									<div class="git-tit">{{item.text}}</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
				</div>
			</section>
			<!-- 参展品牌 -->
			<section v-if="periodsInfo.exhibitionBrandList.length > 0 && periodsInfo.exhibitionBrand==true" class="brand-table-wrap">
				<div class="titleIn brandstyle">
					<div data-v-05565613="" class="exhibitionbrand">
						<span data-v-05565613="" class="lineL"></span> 参展品牌
				        <span data-v-05565613="" class="lineR"></span>
					</div>
				</div>
				<div class=" bigbrandwrap" id="bigbrandwrap">
	                <div class="brand-table  swiper-container" style="height:286px;">
	                    <mt-swipe :auto="0">
	                    	<mt-swipe-item v-for="n in num">
		                        <ul  class="swiper-slide" >
		                            <em class="brand-img"></em>
		                            <li @click="signupPage($event,item.brandId,item.brandName)"  v-if="index>=((n-1)*12) && index<=(n*12-1)" class="trackEvent" data-track="carfestivalDetailToutiao-3-brandLink" v-for="(item,index) in periodsInfo.exhibitionBrandList" >
		                                <a href="##">
		                                    <!-- <input type="hidden" class="js-bshow-id" :value="item.id" /> -->
											<input type="hidden" class="js-bshow-id" value="0" />
		                                    <input type="hidden" class="js-bshow-brandid" :value="item.brandId" />
		                                    <input type="hidden" class="js-bshow-brandlabel" :value="item.label" />
		                                    <input type="hidden" class="js-bshow-brandName" :value="item.brandName" />
		                                    <p>
		                                        <img class="hot-brand-img" :src="commmonWebConfig.picHost+item.brandLogo" />
		                                    </p>
		                                    <p class="hot-brand-tit">{{item.brandName}}</p>
		                                </a>
		                            </li>
		                        </ul>
	                        </mt-swipe-item>
	                    </mt-swipe>
	                    <div class="swiper-pagination"></div>
	                </div>
	            </div>
				<p class="exhibitionbrand-tip">预计84个品牌参展，持续增加中</p>
			</section>
			<section class="">
				<div class="titleIn brandstyle">
					<div data-v-05565613="" class="exhibitionbrand">
						<span data-v-05565613="" class="lineL"></span> 参展指南
				        <span data-v-05565613="" class="lineR"></span>
					</div>
				</div>
				<div class=" bigbrandwrap bigbrandwrapGuids" id="bigbrandwrap ">
					<div class="favourableTit">参展须知</div>
					<p class="favCon brand-table-wrapL">1、车展现场凭门票入场，一票一人，16岁以下不收取门票。</p>
					<p class="favCon brand-table-wrapL">2、线上报名领取车展门票，车展现场不予赠送免费门票，需要在售票处购票入场，售价为20元。</p>
					<p class="favCon brand-table-wrapL">3、签到后可免费领取精美礼品，数量有限，先到先得。</p>
					<img class="favImg" :src="commmonWebConfig.webCommonUtils+'/img/mapply/carExpo/voucher.png'" @click="signupPage()"/>
	            </div>
	            <div class=" bigbrandwrap bigbrandwrapGuids" id="bigbrandwrap ">
					<div class="favourableTit">领票指南</div>
					<p class="favCon brand-table-wrapL">1、点击免费领取门票按钮，按照流程免费报名领取门票，请准确填写信息，否则无法为您安排派送（车展开始前三天不予邮寄）。</p>
					<p class="favCon brand-table-wrapL">2、客服人员跟您确认信息无误后，寄出门票，您将收到4张家庭套票和邀请函。</p>
					<img class="favImg" :src="commmonWebConfig.webCommonUtils+'/img/mapply/carExpo/admission.png'" @click="signupPage()"/>
	            </div>
	            <div class=" bigbrandwrap bigbrandwrapGuids" id="bigbrandwrap ">
					<div class="favourableTit">交通攻略</div>
					<div class="blacksize trafficDre">{{periodsInfo.address}}</div>
					<section class="marB1 addresswrap clearfix bigbrandwrapGuids">
						<div  class="twoadd">
							<div class="lines">
								<img  :src="commmonWebConfig.webCommonUtils+'/img/mapply/carExpo/bus1.png'"> 
								<p  class="road-title">自驾:</p>
							</div> 
							<div  class="promptadd">
								<p  class="point">{{jtResultMap.car}}</p>
							</div>
						</div>
		                <div class="metro">
		                    <div class="underground">
		                        <img :src="commmonWebConfig.webCommonUtils+'/img/mapply/carExpo/bus2.png'">
		                        <p class="road-title">公交:</p>
		                    </div>
		                    <div class="threeadd">
		                        <p class="point ">{{jtResultMap.bus}}</p>
		                    </div>
		                </div>
		                <div class="metro">
		                    <div class="underground">
		                        <img :src="commmonWebConfig.webCommonUtils+'/img/mapply/carExpo/bus3.png'">
		                        <p class="road-title">地铁:</p>
		                    </div>
		                    <div class="threeadd">
		                        <p class="point ">{{jtResultMap.subway}}</p>
		                    </div>
		                </div>
	                </section>
	            </div>
			</section>
			<!-- 服务保障 -->
			<carExpopromiseComponent v-on:signupPageComponent="signupPage"></carExpopromiseComponent>
			<!-- 往期回顾 -->
			<section class="" style="width: 100%;overflow: hidden;">
				<div class="titleIn brandstyle">
					<div  class="exhibitionbrand">
						<span data-v-05565613="" class="lineL"></span> 往期回顾
				        <span data-v-05565613="" class="lineR"></span>
					</div>
				</div>
				<div class="modelwrapBac">
					<div class="modelwrap" v-for="(item,index) in autoShowInfo.lookbackList">
							<a class="reviewImg" href="javascript:void(0);" v-if="index==0" style="margin-top: 0.42rem;margin-left: 0.3rem;margin-bottom: 0.13rem;margin-right: 0.13rem;">
								<img  v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName">
							</a>
							<a class="reviewImg" href="javascript:void(0);"  v-if="index==1" style="margin-top: 0.42rem;margin-bottom: 0.13rem;">
								<img  v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName">
							</a>
							<a class="reviewImg" href="javascript:void(0);"  v-if="index==2" style="margin-bottom: 0.42rem;margin-left: 0.3rem;margin-right: 0.3rem;margin-right: 0.13rem;">
								<img  v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName">
							</a>
							<a class="reviewImg" href="javascript:void(0);"  v-if="index==3" style="margin-bottom: 0.42rem;margin-right: 0.3rem;"> 
								<img  v-lazy="commmonWebConfig.picHost+autoShowInfo.picUrl+item.imageName">
							</a>
					</div>
				</div>
			</section>
			<div class="tikect-fixed trackEvent" data-track="carfestivalDetailToutiao-2-signUpFixed" @click="trackEvent()">
		        <span class="line">￥20<em></em></span>立即报名
			</div>
			<div class="topBack"></div>
			
			
			<!-- 弹窗蒙层 -->
		    <!--<div class="pop-mark " @click="popMark()"></div>
		    <div class="showmarsk">
		        <form class="formwrap" id="maskform">
		        	<div class="markdel"  @click="markdels()"></div>-->
		        	 <!--<div v-if="car == 1" class="sinform">
                        <em class="icon-arror-l"></em>
                        <div class="sinform-text" id="maskbrand"  @click="getData($event)">请选择意向品牌或车型</div>
                        <div class="icon-arror-r"></div>
                    </div> -->
		            <!--<div class="sinform">
		                <em class="signUpfrom-icon signUpfrom-icon01"></em>
		                <input type="text" class="sinform-text" name="showmarskname" placeholder="请输入姓名" maxlength="10" id="mask-usernane">
		            </div>
		            <div class="sinform">
		                <em class="signUpfrom-icon signUpfrom-icon02"></em>
		                <input type="tel" autocomplete="off" class="sinform-text" name="showmarskphone" placeholder="请输入手机号码" maxlength="11" id="msak-phone">
		            </div>-->
		            <!--<div class="inputwrap code-warp">
		                <input id="pop-code" type="tel" placeholder="请输入验证码" class="code">
		                <button type="button" class='code-btn' id="pop-code-btn"  @click="codeBtn($event,'#'+$event.target.id)">获取验证码</button>
		            </div>-->
		            <!--<div class="mask-wrap">
                        <div class="singsubmit" @click="submitTop('#maskbrand',2)" id="mask-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
                            <span class="line">￥20<em></em></span>立即免费领票
                        </div>
		                <div class="agreement">
		                    *请放心填写,报名即视为同意
		                    <span class="protocol" id="mask-protocol"  @click="addxydetail()">《个人信息保护声明》</span>
		                </div>
		            </div>
		        </form>
		    </div>-->
		    
		    
		    
			<!-- 蒙层弹窗 -->
			<div class="pop-mark"></div>
			<div class="markwrap">
				<form id="myform" class="myform">
					<div id="markdel" class="markdel" @click="cloMen"></div>
					<div id="money01" class="money01"></div>
					<div id="money02" class="money02"></div>
					<div id="money03" class="money03"></div>
					<div id="money04" class="money04"></div>
					<div id="money05" class="money05"></div>
					<div class="popup">
						<div class="inputwrap">
							<input type="hidden" id="telval">
							<input type="hidden" id="brandval">
							<input type="hidden" id="posval">
							<input type="hidden" id="msgval" />
							<input type="hidden" id="titleval" />
							<input type="tel" maxlength="11" placeholder="请输入您的手机号" class="phone">
						</div>
						<div class="pop-lucencywrap">
							<div @click="subApplyPopBrand()" class="signupnow ">立即报名</div>
						</div>
						<div style="color:#f0f0f0; margin-top:0.5rem" class="addxyroom">*请放心填写,报名即视为同意<a style="color:#fff;" href="javascript:void(0);" class="addxydetail" @click="addxydetail()">《个人信息保护声明》</a> </div>
						<div class="pop-luc-discounts">
							<div class="signupnow" id="js-discount">领取优惠</div>
						</div>
					</div>
					<div class="font-size" id="preferential">
						优惠使用说明：
						<br> 1、该优惠券将以短信形式发送到您的手机，请注意查收
						<br> 2、此券自领取时间起一个月内有效，逾期不可使用
						<br> 3、领取该优惠券的用户需在有效期内到指定地点购车并使用该券
						<br> 4、在满足使用条件的前提下，单笔订单最多使用一张优惠券
						<br> 5、本优惠券不可兑换现金
						<br> 6、本次活动最终解释权归团车互联网信息服务（北京）有限公司所有
					</div>
				</form>
			</div>
			<!-- 底部 -->
			<carExpofooterComponent></carExpofooterComponent>
			<!--<carExpofooter></carExpofooter>-->
			<!--协议-->
			<agreementComponentQuo></agreementComponentQuo>
			<!--协议-->
		</div>
		
		<!--在线客服 s-->
		<div class="onlineservice">
			<div class="iconwrap"></div>
			<div class="moreCar">更多车展详情</div>
			<div class="buttonClick">点击咨询</div>
		</div>
		<div class="onlineperson"></div>
		<!--在线客服 end-->
		<!-- 侧拉品牌 -->
		<div id="sider-mark" class="sider-mark"></div>
		<div id="sider-wrap" class="sider-wrap">
			<div id="side-brand" class="side-div side-brand">
				
			</div>
			<div id="side-carstyle" class="side-div side-carstyle">
			</div>
		</div>
		<div id="adPop-mark" class="adPop-mark"></div>
		<div id="adPop" class="signUpfrom adPop">
			<div class="adPop-tit">请先选择您中意的车型</div>
			<form id="signUpfromPop">
				<div class="signUpform-com">
					<em class="signUpfrom-icon signUpfrom-icon01"></em>
					<input id="userNamePop" name="userName" placeholder="请输入姓名" class="signUpfrom-txt userName" type="text" maxlength="10" />
				</div>
				<div class="signUpform-com">

					<em class="signUpfrom-icon signUpfrom-icon02"></em>
					<input id="telphonePop" name="telphone" placeholder="请输入手机号码" class="signUpfrom-txt telphone" type="tel" maxlength="11" />
				</div>
				<div class="signUpform-com">
					<em class="signUpfrom-icon signUpfrom-icon03"></em>
					<div id="insertCarPop" class="signUpfrom-txt">请输入意向品牌和意向车型</div>
					<em class="icon-arror-r"></em>
				</div>
				<div id="adPopBtn" class="adPopBtn">
					下一步
				</div>
			</form>
		</div>

	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	.active{
	    background: #ff3938;
	    border:0;
	}
	.noclick{
		pointer-events: none;
	}
</style>
<script>
function trackerAD(accountId) {
	TDH5SDK.account.register(accountId, null, null, null, null, null);
}

//import data from "@/data/data.js"
import { Toast } from 'mint-ui';
export default {
	name: 'index',
	data:function() {
		return {
			bodyIsShow:false,
			num:0,
			numbers:'',
			number1:'',
			number2:'',
			number3:'',
			number4:'',
			showAddress:-1,
			city:{
				name:"北京"
			},
			indexTab:0,
			autoShowInfo:{
				applyprocessList:[],
				showApplyprocess:true,
				showCountdown:true,
				showApplynum:false,
				isShowTmallUrl:1,
				present:false,
				presentTips:false,
				presentList:[],
				lookbackList:[],
				picUrl:"",
				hotDiscount:1,
				hotDiscountList:[],
				news:null,
				newsVideolink:null,
				newsDesc:"",
				newsList:[],
				freedom:-1,
				freedomList:[],
				dealerList:[],

				tAutoshowPeriodsOcpc:null

			},
			deadline:10000,
			periodsInfo:{
				id:"",
				ticketPrice:20,
				noticeTitle:"而且有日期",
				notice:null,
				presentTitle:"",
				noticeList:[],
				exhibitionBrand:true,
				exhibitionBrandList:[],
				longitudeLatitude:null,
				title:"",
				address:"",
				qrcodeImg:"",
				weixin:"",
				isShowTicket:'',
				timeDifference:'',
				giftPrice:'',
				present:''
			},
			jtResultMap:{},
			adSpaceObj:null,

			appPersonNum:0,
			applyListMap:[],
			showBrandNum:11,
			ocpcId:"",
			presentList0:[],
			presentList1:[],
			presentList2:[],
			presentList3:[],
			isActive:-1,
			presentListTit0:'',
			presentListTit1:'',
			presentListTit2:'',
			presentListTit3:'',
			isBrandCarStyleId: false,	//判断首次加载未选择品牌和车型
			activityType:'9',            //场次类型
			cityId: '10',
			isclick:false
		}
	},
	mounted:function(){
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
			cssURL: "/css/mapply/carExpo/carExpopage.css?v=123"
		});
		
		//确保重要依赖的js加载完成
		getCommonJsIns.initJSNEW(this.webReady);
		
		
		//统计
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

	    ga('create', 'UA-28316522-1', 'auto');
	    ga('send', 'pageview');



	    /*添加tracking_sdk统计代码*/
		var script=document.createElement('script');
        script.type="text/javascript";
        script.id = "td_tracking_sdk";
        script.vn = "1";
        script.vc = "2";
        script.src = this.commmonWebConfig.static+"/js/stat/build/load.min.js?ak=32F583CFF4DD44308125FF29548E1F2F";
        document.body.appendChild(script);
        

		
		String.prototype.GetValue = function (para) {
			var reg = new RegExp("(^|&)" + para + "=([^&]*)(&|$)");
			var r = this.substr(this.indexOf("\?") + 1).match(reg);
			if (r != null && r[2].indexOf("#") > 0) {
				r[2] = r[2].substring(0, r[2].indexOf("#"));
			}
			if (r != null) return decodeURI(r[2]); return null;
		};

		/*添加tracking_sdk统计代码*/
		
		/***统计添加**/
		!function(e, t, n, g, i) {
		    e[i] = e[i] || function() { 
		    	(e[i].q = e[i].q || []).push(arguments)
		    };
		    var n = t.createElement("script");
		    var tag = t.getElementsByTagName("script")[0];
		    n.async = 1;
		    n.src = ('https:' == document.location.protocol ? 'https://': 'http://') + g;
		    tag.parentNode.insertBefore(n, tag);
		} (window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
		gio('init', '8004d11f5708cccc', {});
		//custom page code begin here
		//custom page code end here
		gio('send');
		gio('enableHT', 'true');
		/***统计添加**/

		/***********ocpa统计代码 start************/
		!function(g,d,t,e,v,n,s){if(g.gdt)return;v=g.gdt=function(){v.tk?v.tk.apply(v,arguments):v.queue.push(arguments)};v.sv='1.0';v.bt=0;v.queue=[];n=d.createElement(t);n.async=!0;n.src=e;s=d.getElementsByTagName(t)[0];s.parentNode.insertBefore(n,s);}(window,document,'script','//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js');
		gdt('init','1107859393');
		gdt('track','PAGE_VIEW');
		/***********ocpa统计代码 end************/
		
	},
	methods:{
		tojiIcpc:function(ocpcId){
			var ocpcId = ocpcId;
			(function (root) {
			    root._tt_config = true;
			    var ta = document.createElement('script'); ta.type = 'text/javascript'; ta.async = true;
			    ta.src = document.location.protocol + '//' + 's3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
			    ta.onerror = function () {
			        var request = new XMLHttpRequest();
			        var web_url = window.encodeURIComponent(window.location.href);
			        var js_url = ta.src;
			        var url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + web_url + '&js_url=' + js_url + '&convert_id=' + ocpcId;
			        request.open('GET', url, true);
			        request.send(null);
			    }
			    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ta, s);
			})(window);
		},
		trackEvent:function(){
			var formwrapSection = $("#formwrapSection").offset().top;
			$(window).scrollTop(formwrapSection);
		},
		cloMen:function(){
			$(".markwrap").hide();
			$(".pop-mark").hide();
		},
		webReady:function(){
			var self = this;
			if(self.$route.query.activityType==undefined){
				//
			}else{
				self.activityType=self.$route.query.activityType;
			}
			this.scollTop();
			this.ajaxSubmit.ajax({
				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcj+"/"+this.$route.query.cityPy+"?periodsType="+self.activityType+"&autoShowContentType=8",
				//url:"http://oo.tuanche.com:8083/data/data.js"
//				url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcj+"/"+this.$route.params.cityPy,
				async:false,
				type:"get",
				dataType:"json",
				success:function(data){
					var result = data.response.result;
					if(data.responseHeader.status == 200){
//						console.log(result.periodsInfo+'111111111111222222222222222233333333333');
//						console.log(result.periodsInfo.id+'111111111111222222222');
						self.bodyIsShow = true;
						self.showAddress = result.address;
						self.autoShowInfo.headerImg = result.concentMap.autoShowInfo.headerImg;
						self.autoShowInfo.headerImgb = result.concentMap.autoShowInfo.headerImgb;
						self.autoShowInfo.headerImgc = result.concentMap.autoShowInfo.headerImgc;
						self.autoShowInfo.applyprocessList = result.concentMap.autoShowInfo.applyprocessList;
						self.autoShowInfo.showApplyprocess =  result.concentMap.autoShowInfo.showApplyprocess;
						self.autoShowInfo.showCountdown = result.concentMap.autoShowInfo.showCountdown;
						self.autoShowInfo.lookbackList = result.concentMap.autoShowInfo.lookbackList;
						self.autoShowInfo.isShowTmallUrl = result.periodsInfo.showTmallUrl;
						if(typeof(result.concentMap.adSpaceObj) != "undefined"){
							self.adSpaceObj = result.concentMap.adSpaceObj
						}
						self.autoShowInfo.showApplynum = result.concentMap.autoShowInfo.showApplynum;
						self.num = Math.ceil(result.periodsInfo.exhibitionBrandList.length/12);
						
						
						
						
						self.autoShowInfo.presentTips = result.concentMap.autoShowInfo.presentTips;
						self.autoShowInfo.presentList = result.concentMap.autoShowInfo.presentList;
						for(var i in result.concentMap.autoShowInfo.presentList){
							console.log(result.concentMap.autoShowInfo.presentList[i].labelType);
							if(result.concentMap.autoShowInfo.presentList[i].labelType==0){
								self.presentList0.push(result.concentMap.autoShowInfo.presentList[i].id);
								self.presentListTit0="签到礼";
							}
							if(result.concentMap.autoShowInfo.presentList[i].labelType==1){
								self.presentList1.push(result.concentMap.autoShowInfo.presentList[i].id);
								self.presentListTit1="订车礼";
							}
							if(result.concentMap.autoShowInfo.presentList[i].labelType==2){
								self.presentList2.push(result.concentMap.autoShowInfo.presentList[i].id);
								self.presentListTit2="抽奖礼";
							}
							if(result.concentMap.autoShowInfo.presentList[i].labelType==3){
								self.presentList3.push(result.concentMap.autoShowInfo.presentList[i].id);
								self.presentListTit3="互动礼";
							}
						};
						var htObj = document.getElementsByTagName("html")[0].style.fontSize;
						var htObjValue = htObj.substring(0,htObj.length-2);
						self.number1=self.presentList0.length*htObjValue*2.77;
						self.number2=self.presentList1.length*htObjValue*2.77;
						self.number3=self.presentList2.length*htObjValue*2.8;
						self.number4=self.presentList3.length*htObjValue*2.8;
						self.numbers=(result.concentMap.autoShowInfo.presentList.length+3)*2.5;
						
						
						self.autoShowInfo.picUrl = result.concentMap.autoShowInfo.picUrl;

						self.autoShowInfo.hotDiscount = result.concentMap.autoShowInfo.hotDiscount;
						self.autoShowInfo.hotDiscountList = result.concentMap.autoShowInfo.hotDiscountList;

						self.autoShowInfo.news = result.concentMap.autoShowInfo.news;
						self.autoShowInfo.newsVideolink = result.concentMap.autoShowInfo.newsVideolink;
						self.autoShowInfo.newsDesc = result.concentMap.autoShowInfo.newsDesc;
						self.autoShowInfo.newsList = result.concentMap.autoShowInfo.newsList;

						self.autoShowInfo.freedom = result.concentMap.autoShowInfo.freedom;
						self.autoShowInfo.freedomList = result.concentMap.autoShowInfo.freedomList;
						self.autoShowInfo.tAutoshowPeriodsOcpc = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc;
						if(result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc!=null){
							self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
							self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal = result.concentMap.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal;
							self.tojiIcpc(self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId);

						};
						self.appPersonNum = result.concentMap.appPersonNum;
						self.applyListMap = result.applyListMap;
						self.periodsInfo.present = result.periodsInfo.present;
						self.periodsInfo.isShowTicket = result.periodsInfo.isShowTicket;
//						self.periodsInfo.timeDifference=result.periodsInfo.endTime-result.periodsInfo.beginTime;
						self.periodsInfo.timeDifference=result.concentMap.deadline;
						self.periodsInfo.id = result.periodsInfo.id;
						self.periodsInfo.ticketPrice = result.periodsInfo.ticketPrice;
						self.periodsInfo.notice = result.periodsInfo.notice;
						self.periodsInfo.noticeList = result.periodsInfo.noticeList;
						self.periodsInfo.exhibitionBrand = result.periodsInfo.exhibitionBrand;
						self.periodsInfo.exhibitionBrandList = result.periodsInfo.exhibitionBrandList;
						self.periodsInfo.longitudeLatitude = result.periodsInfo.longitudeLatitude;
						self.periodsInfo.presentTitle = result.periodsInfo.presentTitle;
						self.periodsInfo.giftPrice = result.periodsInfo.giftPrice;
						self.periodsInfo.title = result.periodsInfo.title;
						self.periodsInfo.address = result.periodsInfo.address;
						self.periodsInfo.qrcodeImg = result.periodsInfo.qrcodeImg;
						self.periodsInfo.weixin = result.periodsInfo.weixin;
						self.activityType = result.periodsInfo.activityType;
						document.title=result.periodsInfo.title;
						
						if(typeof(result.concentMap.car) != "undefined"){
							self.jtResultMap.car = result.concentMap.car;
						}
						if(typeof(result.concentMap.bus) != "undefined"){
							self.jtResultMap.bus = result.concentMap.bus;
						}
						if(typeof(result.concentMap.subway) != "undefined"){
							self.jtResultMap.subway = result.concentMap.subway;
						}
						self.deadline = result.concentMap.deadline;

						window.cityId = result.periodsInfo.cityId;
						window.py = self.$route.query.cityPy;
						window.weChatShareData = { py: py, shareType: 'hmtcj' };
						// window.addressType = 2;
						// window.indexInstalments = '0';
						// window.indexOtherbrand = '0';
						// window.indexNewbyV = '0';
						//引进私有文件
//						getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/carfestival/detail.js",function(){
							//console.log(self.periodsInfo);
//							}
						self.timeStart();
						getCommonJsIns.loadJs(getCommonJsIns.scriptUrl["kxbdmarquee"],function(){
							self.kxbdMarq("#showPerson");
						});
						self.tabData(0);
//						console.log(self.periodsInfo.id+'333333333333');
//						var scrol1Obj = document.getElementById('scrol1Obj');
//						scrol1Obj.onscroll=self.scollLeft();
//						scrol1Obj.addEventListener("scroll", self.scollLeft);
//						self.scollLeft()
						
					}
					else{
						// self.$router.push({path: '/hmtcj/end'});
						if(data.response.result.cityId){
							window.cityId = data.response.result.cityId;
						}else{
							window.cityId = self.cityId;
						}
            			window.location.href=SIGNTUREURL.signURL+'/bmtcj?cityId='+window.cityId;
					}
				},
				error:function(data){
					if(data.response.result.cityId){
						window.cityId = data.response.result.cityId;
					}else{
						window.cityId = self.cityId;
					}
					window.location.href=SIGNTUREURL.signURL+'/bmtcj?cityId='+window.cityId;
				}
			});
			
		},
		tabScroll: function(){ 
			var self=this;
//			var fixedDom = document.getElementById('scrol1Obj');
//      	document.addEventListener('scroll',winScroll,false);
//      	function winScroll(e){
//          if(fixedDom.offsetLeft < document.body.scrollLeft){
//                
//          };
//          if(fixedDom.offsetLeft > document.body.scrollLeft){
//                
//          };
//         }
//			
//			var scrol = document.getElementById('scrol1Obj').scrollLeft
//			var scrol == document.querySelector('#scrol1Obj').offsetLeft;
			var scrol = $("#scrol1Obj").scrollLeft();
			if(scrol >=0&&scrol <self.number1-5){
//				alert(124)
				self.isActive=0;
			}else if(scrol >=self.number1-5&&scrol <self.number1+self.number2-5){
//				alert(2)
				self.isActive=1;
			}else if(scrol >=self.number1+self.number2-5&&scrol <self.number1+self.number2+self.number3-5){
//				alert(3)
				self.isActive=2;
			}else if(scrol >=self.number1+self.number2+self.number3-5){
//				alert(4)
				self.isActive=3;
			}
			
//			$("#scrol1Obj").scroll(function() {
//				if($("#scrol1Obj").style.left > 0) {
//					alert(1)
//
//				} else {
//					alert(2)
//				}
//			});
//			$('#scrol1Obj').on('scroll',function(){
//			    // div 滚动了
//			    alert('滚动了');
//			    if ($('#scrol1Obj').scrollTop() >= (1000-200)) {
//			        // 滚动到底部了
//			        alert('滚动到底部了');
//			    }
//			});
		},
		scollTop: function() {
			$(window).scroll(function() {
				if($(window).scrollTop() > $("#index-submit").offset().top) {
					$(".tikect-fixed").show();
					$(".topBack").show();

				} else {
					$(".tikect-fixed").hide();
					$(".topBack").hide();
				}
			});

		},
		tabData:function(index){
//			alert(1)
			this.isActive=index;
			this.indexTab=index;
			var self = this;
			if(index==0){
			$("#scrol1Obj").scrollLeft(0);
//			debugger
			}
			if(index==1){

			$("#scrol1Obj").scrollLeft(self.number1);
			}
			if(index==2){

			$("#scrol1Obj").scrollLeft(self.number1+self.number2);
			}
			if(index==3){

			$("#scrol1Obj").scrollLeft(self.number1+self.number2+self.number3);
			}
		},
		timeEnd:function() {
			alert("活动已结束");
		},
		timeStart:function() {
			var self = this;
			if(self.deadline > 0) {
				webCommonUtil.timer.init(self.periodsInfo.timeDifference, $("#showTime"), self.timeEnd);
			};
		},
		kxbdMarq: function(obj){
			$(obj).kxbdMarquee({
				direction: "up",
				isEqual: false,
				scrollDelay: 40
			});
		},
		brandPop:function(event){
			var obj = event.currentTarget;
			$(".pop-mark").css({
				position: "fixed",
				display: 'block',
				height: "100%",

			});
			$("#sigdiscounts").hide();
			$("#sin-lucency").show();
			$("#tikect-btn-fixed").hide();
			$("#font-size").show();
			$("#preferential").hide();
			$(".markwrap").show();
			$("#js-brand").show();
			$("#js-discount").hide();
			var surval = $(obj).find('.js-bshow-id').val();
			var curval = $(obj).find('.js-bshow-brandid').val();
			var fontsize = $(obj).find('.js-bshow-brandlabel').val();
			if(fontsize != "") {
				$("#font-size").html(fontsize).show();
			} else {
				$("#font-size").hide();
			};
			//console.log("fontsize:"+fontsize);

			$("#telval").val(surval);
			$("#brandval").val(curval);
			// 获取缓存
			var cookieval = webCommonUtil.cookie.getCookie("tcjphone");
			// alert(cookieval);
			$(".phone").val(cookieval); //放到页面
			$("#posval").val(3);
		},
		subApply:function(data){
			var self = this;
			$("#tikect-sub").attr("disabled","disabled");
			$("#signUpButton").attr("disabled","disabled");
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
//				url:"http://172.16.3.138:8080/adConfig/tcj/applyForTcjAsyn",
				type:"post",
				data:data,
//				contentType: 'application/json;charset=UTF-8',
				success:function(data){
					if(data.responseHeader.status == 200){
						$("#tikect-sub").removeAttr("disabled");
						$("#signUpButton").removeAttr("disabled");
						self.isclick=false;
						// console.log(data);
						if(data.response.result.code == 10000) {
							var c = document.location.href.GetValue("c");
							if(self.autoShowInfo.tAutoshowPeriodsOcpc != null && c == self.autoShowInfo.tAutoshowPeriodsOcpc.promotionCanal) {
								var id = self.autoShowInfo.tAutoshowPeriodsOcpc.ocpcId;
								if(id != "") {
									_taq.push({
										convert_id: id,
										event_type: "form"
									});
								}
							}
//							trackerAD(data.response.result.applyId);
							//写缓存                           
//							webCommonUtil.cookie.addCookie("tcjphone", $("#telphone").val(), 1);

//							console.log(self.periodsInfo.id+ new Date());
							window.location.href ="/mapply/carExpo/carExpoperfect/suc?applyId=" + data.response.result.result.applyId +"&activityType="+self.activityType+ "&t=" + Date.parse(new Date()) + "&buyway=0&instalments=0&otherbrand=0&periodsId=" + self.periodsInfo.id+"&cityId="+cityId+"&sk="+data.response.result.result.sk+"&cityPy="+self.$route.query.cityPy;
							$("#tikect-sub").removeAttr("disabled");
						} else if(data.response.result.code == -99999) {
							$(".code-warp").show();
						} else {
							console.log(data.response.result.code+"1111111111");
							console.log(data.response.result.code+"22222222");
							Toast({
			                  message: data.response.result.msg,
			                  position: 'middle',
			                  duration: 2000
			                });
						}

					}
					
				},
				error:function(){
					$("#tikect-sub").removeAttr("disabled");
					$("#signUpButton").removeAttr("disabled");
					self.isclick=false;
					Toast({
	                  message: "系统忙，请稍后",
	                  position: 'middle',
	                  duration: 2000
	                });
				}
			});
			/******增加OCPA统计代码 start******/
			try {
				window.gdt('track', 'RESERVATION', {'key1': 'value1', 'key2': 'value2'});
			} catch (err) {
				console.log(err.message);
			}
			/******增加OCPA统计代码 end******/
		},
//		subApplyPopBrand:function(){
//			var mobileReg = /^[1][0-9]{10}$/;
//			var mobileNum = $.trim($(".phone").val());
//			$("#js-brand").attr("disabled", "disabled");
//			var buyType = "";
//			var splitMoney = "";
//			var otherbrand = "";
//			if(!mobileReg.test(mobileNum)) {
//				Toast({
//                message: "请输入11位手机号码",
//                position: 'middle',
//                duration: 2000
//              });
//				return false;
//
//			}
//			else {
//				var data = {
//					"sourceUrl": window.location.href,
//					"cityId": cityId,
//					"name": $("#userName").val(),
//					"phone": $(".phone").val(),
//					"groupbyNum": $('#groupbyNum').val(),
//					"position": $("#posval").val(),
//					"groupbyType": $("#groupbyType").val(),
//					"buyType": buyType,
//					"splitMoney": splitMoney,
//					"otherBrand": otherbrand,
//					"brandId": $("#brandval").val(),
//					"checkIp": true
//					
//				};
//				this.subApply(data);
//				$("#js-brand").attr("disabled", "disabled");
//			}
//		},
		getData:function(event){
			var self = this;
          webCommonUtil.getBrandCarStyle.init({
              domObj:event.target,
              callback:function(){
                //console.log($("#aa").data("carstyleiName"));
				self.isBrandCarStyleId = true;
              },
              ajaxBrandParams:{
                url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcBrand,
                type:"post",
                dataType:"json",
                async:false,
                data:{
                  cityId:window.cityId,
                  state:self.activityType,
                }
              },
              ajaxCarStyleParams:{
                url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.baseDataTcStyle,
                type:"post",
                dataType:"json",
                async:false,
                data:{
                  cityId:window.cityId
                }
              }
            });
     	},
//   	trackEvent:function(){
//			$('.pop-mark').show();
//			$(".showmarsk").show();
//			$(".showmarsk .markdel").show();
//		},
     	markdels:function(){
			$('.pop-mark').hide();
			$(".towshowmarsk").hide();
			$(".markdel").hide();
			$(".tow-mask-brand p").hide();
			$('html').css({
				"overflow": "auto"
			});
			//关闭弹窗还回到点击的位置
			$('body', 'html').css({
				"position": "static",
				"width": "10rem",
				"margin": "0 auto"
			});
			$(".showmarsk").hide();
			$('.pop-mark').hide();
			$(window).scrollTop(brandTop);
		},
		popMark:function(){
			$('.pop-mark').hide();
			$('.sider-wrap').hide();
			$(".showmarsk").hide();
			$(".towshowmarsk").hide();
			$(".markdel").hide();
			$(".tow-mask-brand p").hide();
			$('html').css({
				"overflow": "auto"
			});
			//关闭弹窗还回到点击的位置
			$('body', 'html').css({
				"position": "static",
				"width": "10rem",
				"margin": "0 auto"
			});
		},
     	addxydetail:function(){
			// $(".xymarsk").show();
			// $(".addxypop-mark").show();
			// $('html').css({
			// 	"overflow-y": "hidden"
			// });
			// $('body', 'html').css({
			// 	"position": "fixed",
			// 	"left": "50%",
			// 	"margin-left": "-5rem",
			// 	"top": 0
			// });
      		agreementUtil.agreement.init();

		},
		checkData:function(name,phone,objId){
			if($(name).val()=='' || !webCommonUtil.commonFun.isName($(name).val())){
				Toast({
                  message: "请填写真实姓名",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else if(!webCommonUtil.commonFun.isPhone($(phone).val())){
				Toast({
                  message: "请填写11位手机号码",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else if(!this.isBrandCarStyleId || $(objId).data("brandId") == ''|| $(objId).data("carstyleId")==''){
				Toast({
                    message: "请选择品牌和车型",
                    position: 'middle',
                    duration: 2000
                });
                return false;
			}
			else {
				return true;
			}
		},
     	submitSignup:function(names,phones,objId){
//			$("#js-brand").attr("disabled", "disabled");
//			$("#signUpButton").removeAttr("disabled");
			var self = this;
//			debugger
			var brandType =$(objId).data("brandId");
			var carType =$(objId).data("carstyleId");
			var buyType = "";
			var splitMoney = "";
			var otherbrand = "";
			var checkStatus;
			checkStatus = self.checkData(names,phones,objId);
			console.log($(objId).data("brandId"));
			console.log($(objId).data("carstyleId"));
			if(checkStatus){
				var curWindow = window.location.href;
				var data = {
					"sourceUrl": curWindow,
					"cityId": cityId,
					"name": $(names).val(),
					"phone": $(phones).val(),
					"groupbyNum": self.periodsInfo.id,
					"groupbyType": self.activityType,
					"buyType": buyType,
					"splitMoney": splitMoney,
					"otherBrand": otherbrand,
					"checkIp": true,
					"noCheckBrandStyle":0,
					"sourceId":'-1',
					"bmtype":'carfair_blue_apply'
				};
				data["brandId"]=$(objId).data("brandId");
				data["carStyleId"]= $(objId).data("carstyleId");
				self.isclick=true;
				self.subApply(data);
				
			}
		},
		signupPage:function(obj,brandId,brandName){
//			alert(13);
			var self=this;
			if(obj!=undefined){
				window.location.href="/mapply/carExpo/carExpoSignup?cityPy="+self.$route.query.cityPy+"&activityType="+self.activityType+"&cityId="+cityId+"&groupbyNum="+self.periodsInfo.id+"&brandId="+brandId+"&brandName="+brandName;
			}else{
				window.location.href="/mapply/carExpo/carExpoSignup?cityPy="+self.$route.query.cityPy+"&activityType="+self.activityType+"&cityId="+cityId+"&groupbyNum="+self.periodsInfo.id;
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/views/carExpo/carExpopage.vue